import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { type TabItem } from './TabContent.types';

export const TabContent: React.FC<TabItem> = ({ icon, title }) => (
    <Stack justifyContent="center" gap={{ default: '1' }}>
        <Container marginTop="0.5" hidden={{ default: true, sm: false }}>
            {icon}
        </Container>
        <Container textAlign="start">
            <Typography size={{ default: 'b_sm', sm: 'b_md' }} color="grey_1200">
                {title}
            </Typography>
        </Container>
    </Stack>
);

TabContent.displayName = 'TabContent';
